import { createContext } from 'react';

import { ToastProp } from '@components/toasts/toast.types';

export type Toast = {
  id: number;
} & ToastProp;

export type ToastStateType =
  | {
      toasts: Toast[];
      addToast: (toast: Omit<Omit<Toast, 'id'>, 'onClose'>) => number;
      addToasts: (toasts: Omit<Omit<Toast, 'id'>, 'onClose'>[]) => number[];
      removeToast: (id: number) => void;
    }
  | undefined;

export const ToastContext = createContext<ToastStateType>(undefined);
